/*
 * Public API Surface of @smartera/animations
 */

export * from './lib';
